import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/posts";
const pathPostType = "/post-types";
const pathTBED = "/ai-tbeds"

const contentApi = {
  contents(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  contentsTBED(params: any): Promise<any> {
    const url = `${pathTBED}`;
    return api.get(url, params);
  },

  contentTypes(params: any): Promise<any> {
    const url = `${pathPostType}`;
    return api.get(url, params);
  },

  ratingDefinitions(): Promise<any> {
    const url = `${path}/rating-definitions`;
    return api.get(url);
  },

  getContent(id: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url);
  },

  postContent(dataForm: any): Promise<any> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putContent(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  deleteContent(id: any) {
    return api.delete(`${path}/${id}`);
  },
};

export default contentApi;
